<template>
  <v-container fluid>
      <div class="scroll-container">
        <v-card class="pb-2 my-1" tile v-for="(item, index) in news" :key="index" cols="12">
          <v-card-title class="pb-1">
            <div class="notification-title">{{ item.title }}</div>
          </v-card-title>
          <v-card-text class="pt-0">
            <div class="notification-content">{{ item.content }}</div>
            <div class="notification-date">{{ getDateFormatted(item.createDate) }}</div>
          </v-card-text>
        </v-card>
      </div>
      
      <v-form ref="form" lazy-validation class="white v-card mt-3">
        <v-layout row wrap align-center>
          <v-flex xs12 sm9 md10 class="px-3">
            <v-text-field
              ref="title"
              label="Tiêu đề"
              v-model="title"
              :rules="[validate.required]"
              class="pb-2"
            ></v-text-field>
            <v-text-field
              ref="content"
              label="Nội dung"
              v-model="content"
              :rules="[validate.required]"
              class="pb-2"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3 md2 class="text-xs-right px-3">
            <v-btn block color="primary" @click="onSendNotification" :loading="loadingBtn">Gửi <v-icon small right dark>send</v-icon></v-btn>
          </v-flex>
        </v-layout>
      </v-form>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import validate from '../utils/validate';
import { formatSecondToGPSTime } from '../utils/datetime';

export default {
  data: () => ({
    news: null,
    title: '',
    content: '',
    validate: validate,
    loadingBtn: false,
    valid: true
  }),

  created () {
    this.onGetNotifications();
  },

  methods: {
    ...mapActions(['sendNotification', 'getNotifications']),

    async onSendNotification () {
      if (this.$refs.form.validate()) {
        let data = {
          title: this.title,
          content: this.content
        };

        this.loadingBtn = true;
        let res = await this.sendNotification(data).catch(() => {
          return false;
        });
        
        this.loadingBtn = false;

        if (res) {
          window.getApp.showMessage('Gửi thông báo thành công.');
          this.onGetNotifications();
        }
        else { window.getApp.showMessage('Gửi thông báo thất bại.', 'error') }
      }
    },

    async onGetNotifications () {
      let res = await this.getNotifications().catch(() => {
        return null;
      });
      this.news = res;
    },

    getDateFormatted (value) {
      return value ? formatSecondToGPSTime(value) : '';
    }
  }
};
</script>

<style scoped>
.scroll-container{
  height: calc(100vh - 280px);
  overflow-y: auto;
}
.notification-title {
  font-size: 16px;
  font-weight: 600;
}
.notification-content {
  white-space: pre-line;
  color: rgba(0, 0, 0, 0.7);
}
.notification-date {
  margin-top: 8px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
}
/*Width*/
.scroll-container::-webkit-scrollbar {
  width: 10px;
}
/* Track */
.scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
/* Handle */
.scroll-container::-webkit-scrollbar-thumb {
  background: #888; 
  border-radius: 4px;
}
/* Handle on hover */
.scroll-container::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

@media (max-width: 599px) {
  .scroll-container{
    height: calc(100vh - 320px);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Notification.vue